import * as moment from 'moment'
import { IDateable } from '../../ui/components/date-selector/idateable.interface'
import { ProfilePreferences } from '../../ui/components/navigation/profile/profile-preferences.model'

export abstract class AbstractStorageKey<T> {
    key: string
    persistent: boolean

    constructor(key: string, persistent: boolean) {
        this.key = key
        this.persistent = persistent
    }

    abstract parseFromJSON(json: string): T
}

// Regular storage key can be used for simple stored values such as number or strings
export class StorageKey<T> extends AbstractStorageKey<T> {
    parseFromJSON(json: any): T {
        return JSON.parse(json as string)
    }
}

// Storage key for IDateables
export class IDateableStorageKey extends StorageKey<IDateable> {
    parseFromJSON(json: any): IDateable {
        const idateableValue: IDateable = super.parseFromJSON(json)
        if (idateableValue) {
            idateableValue.startDate = moment(idateableValue.startDate)
            idateableValue.endDate = moment(idateableValue.endDate)
        }

        return idateableValue
    }
}

// Storage key for IDateables
export class PreferenceStorageKey extends StorageKey<ProfilePreferences> {
    parseFromJSON(json: any): ProfilePreferences {
        return ProfilePreferences.fromJSON(json)
    }
}
